import type { RouteObject } from "react-router-dom";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getSellerPath } from "@/lib/routing/portal-urls";
import { CategoriesPage } from "@/modules/categories/pages/CategoriesPage";
import { useLocale } from "@seller/app/locale";

function SellerCategoriesRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const notice = searchParams.get("notice") ?? "";
  const showSaveNotice = notice === "category_saved";
  const defaultCreateOpen = searchParams.get("create") === "1";
  const defaultEditId = searchParams.get("edit");

  return (
    <CategoriesPage
      locale={locale}
      storeSlug={storeSlug}
      showSaveNotice={showSaveNotice}
      defaultCreateOpen={defaultCreateOpen}
      defaultEditId={defaultEditId}
    />
  );
}

function SellerCategoryCreateRedirectRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();
  const navigate = useNavigate();
  const target = `${getSellerPath(locale, storeSlug)}/categories?create=1`;

  useEffect(() => {
    navigate(target, { replace: true });
  }, [navigate, target]);

  return null;
}

function SellerCategoryEditRedirectRoute() {
  const locale = useLocale();
  const { storeSlug = "", id = "" } = useParams();
  const navigate = useNavigate();
  const target = `${getSellerPath(locale, storeSlug)}/categories?edit=${encodeURIComponent(id)}`;

  useEffect(() => {
    navigate(target, { replace: true });
  }, [navigate, target]);

  return null;
}

export const categoriesRoutes: RouteObject[] = [
  {
    path: "categories",
    element: <SellerCategoriesRoute />,
  },
  {
    path: "categories/new",
    element: <SellerCategoryCreateRedirectRoute />,
  },
  {
    path: "categories/:id",
    element: <SellerCategoryEditRedirectRoute />,
  },
];
